import { subscribeChannel, publishChannel } from './channelUtils';

export function sendTurnos(turnos) {
    
    publishChannel('turnos-sync', turnos);

}

export function sendTurnosCodes(driver) {
    
    publishChannel('turnos-codes-sync', driver);

}

export function sendTurnosSelected(turnosSelected) {
    
    publishChannel('turnos-selected', turnosSelected);

}

export function listenTurnos(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'turnos-sync' &&
            tipo !== 'turnos-codes-sync' &&
            tipo !== 'turnos-selected'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}